import React from "react";
import {WarehouseBasePage} from "./Base";


export const WarehouseClientPage: React.FC = () => {
    const status = "Отгружено клиентам"
    const preFilters = [
        {
            "id": "status",
            "value": [
                status
            ],
            "condition": "in_list",
            "kind": "select",
            "key": "_status",
            "nested_in": "attributes"
        }
    ]
    const columns = [
        "manufacturer_model",
        "manufacturer",
        "model",
        "hashrate",
        "id",
        "gtd",
        "customer",
        "Installation_date"
    ]
    const fields = [
        "status",
        "Installation_date",
        "customer",
        "manufacturer_model",
        "manufacturer",
        "model",
        "hashrate",
        "gtd",
        "client_comment"
    ]
    return <WarehouseBasePage
        prefix={"client"}
        columns={columns}
        preFilters={preFilters}
        title={status}
        createStatus={status}
        fields={fields}
    />
}